import { render, staticRenderFns } from "./Reestr.vue?vue&type=template&id=1acf6ba8&scoped=true&"
import script from "./Reestr.vue?vue&type=script&lang=js&"
export * from "./Reestr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1acf6ba8",
  null
  
)

export default component.exports